import React from 'react';

const TaxLabelsSection = ({ updatedClient, data, updateField }) => {
    const taxes = [
        { title: 'Tax 1', labelKey: 'tax_1_label', hideKey: 'hide_tax_1_field', placeholder: 'Tax 1' },
        { title: 'Tax 2', labelKey: 'tax_2_label', hideKey: 'hide_tax_2_field', placeholder: 'Tax 2' },
    ];

    return (
        <div className='mb-2'>
            <h5 className='mt-4'>Tax labels</h5>
            {taxes.map(({ title, labelKey, hideKey, placeholder }, index) => (
                <div key={labelKey} className='mt-2'>
                    <h6 className='mb-2'>{title}</h6>
                    <div className='row'>
                        <div className='col-3 col-md-2'>Label :</div>
                        <div className='col-9 col-md-10'>
                            <input
                                className='form-control'
                                value={updatedClient.config?.[labelKey] ?? ''}
                                onChange={(e) => updateField('config', e.target.value, labelKey)}
                                placeholder={placeholder}
                            />
                        </div>
                    </div>
                    <div className='row mt-2 align-items-center'>
                        <div className='col-3 col-md-2'>{data.t.read("client_table.hide")} :</div>
                        <div className='col-9 col-md-10'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id={`${hideKey}-checkbox`}
                                    checked={!!updatedClient.config?.[hideKey]}
                                    onChange={() => updateField('config', !updatedClient.config?.[hideKey], hideKey)}
                                />
                                <label className='form-check-label' htmlFor={`${hideKey}-checkbox`}>
                                    {data.t.read("client_table.hide")} {title}
                                </label>
                            </div>
                        </div>
                    </div>
                    {index === 0 && <div className='my-3' />}
                </div>
            ))}
        </div>
    );
};

export default TaxLabelsSection;
